import formatCnpj from "@brazilian-utils/format-cnpj";
import formatCpf from "@brazilian-utils/format-cpf";
import { Field, Formik } from "formik";
import React, { useCallback, useState } from "react";
import { IoMdArrowBack, IoMdArrowForward } from "react-icons/io";
import { Link } from "react-router-dom";
import { ReactComponent as PermContactCalendar } from "assets/icons/perm_contact_calendar.svg";
import ContainedButton from "components/layout/form/containedButton";
import OutlinedButton from "components/layout/form/outlinedButton";
import TextField from "components/layout/form/textField";
import { HeaderContainer } from "../styles";
import { Container, ContainerButtons, FormContainer } from "./styles";
import api from "services/api";
import { toast } from "react-toastify";
import { cpfCnpjCursorAlign } from "utils/functions";
import { requestGetAccessToken } from '../utils';

const Document = ({ setStep, userInfo, setUserInfo }) => {
  const [loading, setLoading] = useState();

  const handleDocument = useCallback((event, handleChange) => {
    const cursorStart = event.target.selectionStart;
    const cursorEnd = event.target.selectionEnd;
    const numbers = event.target.value.replace(/[^\d]/g, "");
    event.target.value = event.target.value.replace(/[^\d]/g, "");

    if (numbers.length > 0 && numbers.length < 12) {
      event.target.value = formatCpf(numbers);
    }

    if (numbers.length > 11) {
      event.target.value = formatCnpj(numbers);
    }

    cpfCnpjCursorAlign(event, cursorStart, cursorEnd);
    handleChange(event);
  }, [])

  const validateDocument = value => {
    let error;

    if (!value) {
      error = "É obrigatório preencher seus dados!";
    }

    if (!/[^\d-.\/]/.test(value)) {
      const numbers = value.replace(/[^\d]/g, "");

      if (numbers.length > 0 && numbers.length < 11) {
        error = "Insira um CPF válido";
      }

      if (numbers.length > 11 && numbers.length < 14) {
        error = "Insira um CNPJ válido";
      }
    }

    return error;
  };

  const requestUserContacts = useCallback((userId, data, login = '') => {
    api.get(`industrial/customer/v1/users/${userId}/contacts`)
      .then((response) => {
        setUserInfo({ ...data, document: login, contacts: response.data });
        setStep(2);
        setLoading(false);
      })
      .catch((error) => {
        setLoading(false);
        const erro = error.response;

        if (erro) {
          const message = error.response.data.message;

          if (error.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (error.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      }
      );
  }, [userInfo, setUserInfo, toast, setStep]);

  const requestGetUser = useCallback( async(document) => {
    setLoading(true);
    const headers = {
      access_token: await requestGetAccessToken(),
    }
    const login = document.replace(/[^\d]/g, "");
    const params = {
      login,
      "is-active": true,
      _limit: 1,
      _offset: 0
    }

    api.get("industrial/customer/v1/users", { headers, params })
      .then(response => {
        if(response.data.length) {
          const { userId } = response.data[0];
          requestUserContacts(userId, response.data[0], login);
        } else {
          setLoading(false);
          toast.error("Nenhum cpf/cnpj encontrado")
        }
      })
      .catch(error => {
        setLoading(false);
        const erro = error.response;

        if (erro) {
          const message = error.response.data.message;

          if (error.response.status !== 401) {
            toast.error(message);
          }
        } else {
          if (error.response.status !== 401) {
            toast.error("Ocorreu um erro interno na aplicação");
          }
        }
      });
  }, [setUserInfo, toast])

  const handleSubmit = useCallback(async ({ document }) => {
    if(!loading) {
      requestGetUser(document);
    }
  }, [requestGetUser, loading]);

  return (
    <>
      <Container>
        <HeaderContainer>
          <h1>Esqueci minha senha</h1>
          <h2>Informe seus dados abaixo para que possamos lhe ajudar!</h2>
        </HeaderContainer>
        <Formik
          initialValues={{
            document: userInfo && userInfo.document ? userInfo.document : "",
          }}
          onSubmit={handleSubmit}
          render={({ handleChange, handleBlur, values, errors, touched }) => (
            <FormContainer>
              <Field
                validate={validateDocument}
                name="document"
                render={({ field }) => (
                  <TextField
                    {...field}
                    label="Insira seu CPF ou CNPJ *"
                    placeholder="Insira seu CPF ou CNPJ *"
                    errorCondition={errors.document && touched.document}
                    errorMessage={errors.document}
                    isCorrect={!errors.document}
                    value={values.document}
                    LeadingIcon={() => <PermContactCalendar />}
                    onBlur={handleBlur}
                    onClick={() => toast.dismiss()}
                    onChange={e => {
                      handleDocument(e, handleChange);
                    }}
                  />
                )}
              />

              <ContainerButtons>
                <ContainedButton
                  block
                  type="submit"
                  continue
                  loading={loading}
                  disabled={loading || !values.document}
                  id="Avançar"
                  width="100%"
                  TrailingIcon={() => <IoMdArrowForward size={20} />}
                >
                  Continuar
                </ContainedButton>
                <Link to="/">
                  <OutlinedButton
                    width="100%"
                    LeadingIcon={() => <IoMdArrowBack size={20} />}
                    onClick={() => toast.dismiss()}
                  >
                    Voltar
                  </OutlinedButton>
                </Link>
              </ContainerButtons>
            </FormContainer>
          )}
        />
      </Container>
    </>
  );

}

export default Document;
